module.exports = __webpack_public_path__ + "img/noVideo.a1211ca8.png";